import { EvaluationMark } from '@modules/EvaluationModule/enums/EvaluationMark';

export const peerMarkValues = [
  { title: 'Needs development', value: EvaluationMark.NeedsDevelopment },
  { title: 'Successful', value: EvaluationMark.Successful },
  { title: 'Exceeds', value: EvaluationMark.Exceeds },
  { title: "Can't evaluate", value: EvaluationMark.CantEval },
];
